import { RootState } from '@/types/common';
import {
  GenerateReportProps,
  StudentReportContent,
  ClassReportContent,
} from '@/types/generate-report';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import reportThunks from '../thunks/report';

const initialState: GenerateReportProps = {
  studentReport: null,
  classReport: null,
};

const report = createSlice({
  name: 'report',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      reportThunks.getStudentReport.fulfilled,
      (
        state,
        {
          payload,
        }: { payload: { status: string; message: string; data: StudentReportContent } | undefined }
      ) => {
        if (payload) {
          state.studentReport = payload.data;
        }
      }
    );
    builder.addCase(
      reportThunks.getClassReport.fulfilled,
      (
        state,
        {
          payload,
        }: { payload: { status: string; message: string; data: ClassReportContent } | undefined }
      ) => {
        if (payload) {
          state.classReport = payload.data;
        }
      }
    );
  },
});

export const reportActions = report.actions;

export const reportSelector = (state: RootState) => state.report;

export default report.reducer;
